export default function Frame({ children, classes = '', fullscreen = false }) {
  const widthClasses = fullscreen ? '' : 'max-w-7xl mx-auto px-4 lg:px-8';
  return (
    <div className={`${widthClasses} ${classes}`}>
      {children}
    </div>
  );
}
